import React, { useEffect, useState, useSyncExternalStore } from 'react';
import { hasStripeLoadFailed, subscribeStripeLoad } from '../../utils/checkoutStripe';

function StripeLoadNotice({ stripe }) {
  const failed = useSyncExternalStore(subscribeStripeLoad, hasStripeLoadFailed, () => false);
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    if (stripe) return;
    const timer = window.setTimeout(() => setSlow(true), 10000);
    return () => window.clearTimeout(timer);
  }, [stripe]);
  if (stripe || (!failed && !slow)) return null;
  return <div role="alert" className="my-3 text-sm text-center">
    {failed
      ? 'The payment form could not load. Please check your connection and try again.'
      : 'The payment form is taking longer than usual to load. You can wait or reload the page.'}
    <button type="button" className="block mx-auto mt-2 underline"
      onClick={() => window.location.reload()}>Reload payment form</button>
  </div>;
}

export function TrialPaymentNotice({ controller, attempt, stripe }) {
  return <>
    {!attempt.pending && <StripeLoadNotice stripe={stripe} />}
    {controller && !controller.ready && <div role="status" className="my-2 text-sm text-center">
      {controller.error || 'Loading payment options…'}
      {controller.error && <button type="button" className="block mx-auto underline"
        onClick={controller.reloadRequired ? () => window.location.reload() : controller.refresh}>
        {controller.reloadRequired ? 'Reload page' : 'Refresh price'}</button>}
    </div>}
    {attempt.pending && <div role="status" className="my-2 text-sm text-center">
      Payment status is not yet confirmed. Please do not pay again.
      {attempt.pending.secret && <button type="button" className="block mx-auto underline" disabled={attempt.checking}
        onClick={() => attempt.check(stripe)}>Check payment status</button>}
    </div>}
  </>;
}
